import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChild,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BlogTagsService } from './blog-tags.service';
import { ExpandedThemesComponent } from '../../shared/components/sections/expanded-themes/expanded-themes.component';
import { SmallHeaderComponent } from '../../shared/partials/small-header/small-header.component';
import { HeroBannerComponent } from '../../shared/components/hero-banner/hero-banner.component';
import { SingleBlogCardComponent } from '../../shared/components/cards/single-blog-card/single-blog-card.component';
import { ButtonComponent } from '../../shared/components/buttons/button/button.component';

@Component({
  selector: 'app-blog-tag',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ExpandedThemesComponent,
    SmallHeaderComponent,
    HeroBannerComponent,
    SingleBlogCardComponent,
    ButtonComponent,
  ],
  templateUrl: './blog-tags.component.html',
  styleUrl: './blog-tags.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BlogTagComponent {
  latestBlogs: any[] = [];
  isTocExpanded = false;
  slug: string = '';
  blogContainerId = 'blog-tags-container';
  tag: string = '';
  totalCount = 0;
  page = 1;

  private platformId = inject(PLATFORM_ID);

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private blogTagsService: BlogTagsService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const slug = params.get('slug');
      if (slug) {
        this.slug = slug;
        this.fetchBlogsByTagSlug(slug);
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });
  }

  fetchBlogsByTagSlug(slug: string): void {
    this.blogTagsService.getBlogsByTagSlug(slug).subscribe((blogs) => {
      const data = blogs?.data || [];
      this.tag = blogs?.name;
      this.page++;
      this.totalCount = blogs?.totalCount;
      this.latestBlogs = [...this.latestBlogs, ...data];
    });
  }

  scrollToSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      section.classList.add('highlight-section');
      setTimeout(() => section.classList.remove('highlight-section'), 1200);
    }
  }

  htmlSantizer(html: string): SafeHtml {
    if (!html) return this.sanitizer.bypassSecurityTrustHtml('');
    html = html
      .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, '')
      .replace(/<p[^>]*>(\s|&nbsp;|<br\s*\/?>|&#8203;|&#xfeff;)*<\/p>/gi, '')
      .replace(
        /<p[^>]*>\s*(<style[^>]*>[\s\S]*?<\/style>|@[\w-]+\s*{[^}]*})\s*<\/p>/gi,
        ''
      )
      .replace(/<\/?font[^>]*>/gi, '')
      .replace(
        /<([a-z]+)[^>]*>(\s|&nbsp;|<br\s*\/?>|&#8203;|&#xfeff;)*<\/\1>/gi,
        ''
      );
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  navigateToBlog(slug: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.navigate([`blog/${slug}`]);
    }
  }

  loadMoreBlogs(): void {
    this.fetchBlogsByTagSlug(this.slug);
  }
}
